import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rating",
  "use": "rating-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 18\" id=\"rating\"><path d=\"m9.5 0 2.792 5.657 6.243.907-4.518 4.404 1.067 6.218L9.5 14.25l-5.584 2.936 1.066-6.218L.465 6.564l6.243-.907L9.5 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol